import * as React from 'react';
import * as d3 from 'd3';
import { observer } from 'mobx-react';
import { IOptimizerSingleBarParams } from './IOptimizerSingleBarParams';
import { OptimizerArrow } from './../OptimizerArrow/OptimizerArrow';
import { OptimizerSingleBarAxis } from './../OptimizerSingleBarAxis/OptimizerSingleBarAxis';
import { SvgText } from './../SvgText/SvgText';

@observer
export class OptimizerSingleBar extends React.Component<IOptimizerSingleBarParams> {
  private self: any;
  private displayedValue?: number;
  constructor(props: IOptimizerSingleBarParams) {
    super(props, undefined);
    this.displayedValue = this.props.value;
  }

  roundValues() {
    if (this.props.title === 'Spin Rate') {
      if (this.displayedValue) {
        this.displayedValue = Math.round(this.displayedValue);
      }
    } else {
      if (this.displayedValue) {
        this.displayedValue = Math.round(this.displayedValue * 10) / 10;
      }
    }
  }

  render() {
    this.self = this;
    this.roundValues();

    let margins = { top: 20, bottom: 20, left: 5, right: 0 };

    //SVG dimensions
    let svgWidthWithMargins = 195;
    let svgHeightWithMargins = 370;
    let widthOfTheBar = 30;

    //Responsiveness
    if (window.innerWidth >= 1080) {
      margins.right = 10;
      margins.left = 35;
      svgWidthWithMargins = 195;
      widthOfTheBar = 30;
    }

    //Values on the bar ranges
    let minValueOnBarRanges = 125;
    let heightOfTheBarRanges = 80;
    let valueOnArrow = this.displayedValue;
    let valueOnArrowText: string = '';
    if (valueOnArrow) {
      valueOnArrowText = this.displayedValue ? this.displayedValue.toString() : '';
    } else {
      valueOnArrowText = '';
    }

    //Calculate the unit values on top and bottom of the bar
    let differenceBetweenMaxAndMinInputValue = Math.abs(
      (this.props.max ?? 0) - (this.props.min ?? 0)
    );
    let numberOfPixelsPerUnit = heightOfTheBarRanges / differenceBetweenMaxAndMinInputValue;
    let numberOfUnitsFromTheTopToBarRanges = minValueOnBarRanges / numberOfPixelsPerUnit;
    let topValueOnTheBar = (this.props.min ?? 0) - numberOfUnitsFromTheTopToBarRanges;
    let bottomValueOnTheBar = (this.props.max ?? 0) + numberOfUnitsFromTheTopToBarRanges;

    if (valueOnArrow) {
      if (valueOnArrow >= bottomValueOnTheBar) {
        valueOnArrow = bottomValueOnTheBar;
      } else if (valueOnArrow <= topValueOnTheBar) {
        valueOnArrow = topValueOnTheBar;
      }
    }
    //Values on the bar in px
    let heightOfTheBar = 330;
    let numberOfTicks = 10;
    if (Math.abs(topValueOnTheBar - bottomValueOnTheBar) < 10) {
      numberOfTicks = 5;
    } else {
      numberOfTicks = 10;
    }

    //let width = svgWidthWithMargins - margins.left - margins.right;
    let height = svgHeightWithMargins - margins.top - margins.bottom;

    //Units Under Bar
    let unitUnderBarPosition = 345;

    //Scale for Axis
    let axisScale = d3.scale
      .linear()
      .domain([topValueOnTheBar, bottomValueOnTheBar])
      .range([height, 0]);

    //Create the Axis
    let yAxis = d3.svg
      .axis()
      .scale(axisScale)
      .outerTickSize(0)
      .orient('right')
      .ticks(numberOfTicks)
      .tickSize(-widthOfTheBar);

    //Arrow position
    let arrowPointerXPosition = widthOfTheBar / 2;

    return (
      <div className="OptimizerSingleBar col-xs-2">
        <h5 className="parameter-title">{this.props.title}</h5>
        <svg width={svgWidthWithMargins} height={svgHeightWithMargins}>
          <g transform={'translate(' + margins.left + ',' + margins.top + ')'}>
            <g>
              <rect
                className="bar"
                x="0"
                y="0"
                width={widthOfTheBar}
                height={heightOfTheBar}
              ></rect>
              <SvgText
                translateX={0}
                translateY={unitUnderBarPosition}
                fill="#000000"
                fontSize="12pt"
                unit={this.props.unit}
              ></SvgText>
              <rect
                className="barRanges"
                x="0"
                y={minValueOnBarRanges}
                width={widthOfTheBar}
                height={heightOfTheBarRanges}
              ></rect>
              <OptimizerSingleBarAxis
                className="OptimizerSingleBarAxis y axis"
                axis={yAxis}
                scale={axisScale}
                tickSize={numberOfTicks}
                orient="right"
                translate={`translate(${widthOfTheBar},0)`}
              />
              <g transform={`translate(${arrowPointerXPosition},${axisScale(valueOnArrow ?? 1)})`}>
                <OptimizerArrow
                  valueOnArrow={valueOnArrow}
                  valueOnArrowText={valueOnArrowText}
                  minInputValueForBarRange={this.props.min}
                  maxInputValueForBarRange={this.props.max}
                ></OptimizerArrow>
              </g>
            </g>
          </g>
        </svg>
      </div>
    );
  }
}
